import styled from "styled-components";

export const SurveyLinkWrapper = styled.div`
  padding: 24px;
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ToolbarRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const LinkHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  button {
    border: none;
    background-color: #0089cf !important;
    border-radius: 7px;
    color: white !important;
    transition: all ease 0.2s;
    :active {
      box-shadow: inset 0px 0px 3px 3px rgba(0, 0, 0, 0.25) !important;
    }
  }
`;

export const ChartContainer = styled.div`
  margin-top: 16px;
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ButtonSelectCity = styled.div``;
export const CityWrapper = styled.div``;
